import { render, staticRenderFns } from "./TourismPolicy.vue?vue&type=template&id=bc8cf1e4&"
import script from "./TourismPolicy.vue?vue&type=script&lang=js&"
export * from "./TourismPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports